import { useState } from "react";
import { useScrollReveal } from "../hooks/useScrollReveal";
import { track } from "../../../lib/analytics";

export function VideoSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.15, "video");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className="py-16 px-6">
      <div
        ref={ref}
        className={`max-w-3xl mx-auto transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <button
          onClick={() => { const next = !isOpen; track("landing_video_toggled", { opened: next }); setIsOpen(next); }}
          className="w-full flex items-center justify-between gap-4 group text-left"
        >
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-ink">
              Voir Palnia en action
            </h2>
            <p className="mt-2 text-ink-muted text-sm">
              Une vidéo de démonstration complète pour découvrir comment utiliser
              l'application au quotidien.
            </p>
          </div>
          <span className="shrink-0 text-sm text-accent font-medium transition-colors">
            {isOpen ? "Voir moins" : "Voir plus"}
          </span>
        </button>

        <div
          className={`grid transition-all duration-500 ease-in-out ${
            isOpen ? "grid-rows-[1fr] opacity-100 mt-6" : "grid-rows-[0fr] opacity-0 mt-0"
          }`}
        >
          <div className="overflow-hidden">
            <div
              className="aspect-video bg-surface-alt border border-border rounded-2xl
                flex items-center justify-center"
            >
              <div className="text-center">
                <div className="w-16 h-16 mx-auto rounded-full bg-accent/10 border border-accent/20
                  flex items-center justify-center mb-3">
                  <svg className="w-6 h-6 text-accent" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </div>
                <p className="text-sm font-medium text-ink-muted">
                  Vidéo de démonstration — bientôt disponible
                </p>
              </div>
            </div>

            <div className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-3 border-t border-border pt-6">
              {["Interface complète", "Calendrier & agenda", "Kanban & Eisenhower", "Pomodoro & chrono"].map((item) => (
                <span key={item} className="flex items-center gap-2 text-sm text-ink-muted">
                  <svg className="w-4 h-4 text-accent shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
